
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'

export default class Loader extends React.Component {
  render() {
    return <div className='loader' />
  }
}



// WEBPACK FOOTER //
// ./client/components/Loader/index.js